var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplication = function SvgApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11 15.3q.595 0 1.164.087a.64.64 0 0 1 .536.646c0 .452-.432.778-.88.72a6.302 6.302 0 0 0-7.046 5.28c-.057.37-.362.667-.738.667-.399 0-.72-.332-.668-.728A7.7 7.7 0 0 1 11 15.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    d: "M14.324 18.998c0-.386.312-.698.698-.698h2.306v-2.306a.698.698 0 0 1 1.396 0V18.3h2.306a.698.698 0 0 1 0 1.396h-2.306v2.306a.698.698 0 1 1-1.396 0v-2.306h-2.306a.7.7 0 0 1-.699-.698"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.3,
    d: "m9.132 3.943.42.187.317-.333 2.075-2.185 2.074 2.185.317.333.42-.187 1.571-.703v4.766l.008.05q.053.338.053.692a4.444 4.444 0 1 1-8.834-.691l.008-.05V3.24zm6.996 3.883-.112-.51H7.872l-.112.51q-.1.447-.1.922a4.284 4.284 0 1 0 8.468-.922Z"
  })));
};
export default SvgApplication;